import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Image = ({
  size,
  type,
  theme,
  className,
  dataTestId = "image-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <g fillRule="evenodd" clipRule="evenodd">
      <path d="M12.001 11.167a.667.667 0 0 0 .597-.965L9.93 4.869a.667.667 0 0 0-1.193 0L7.335 7.676l-.737-1.474a.667.667 0 0 0-1.193 0l-2 4a.667.667 0 0 0 .596.965h8ZM7.934 9.459l1.4-2.802 1.589 3.176H7.747l.18-.361a.654.654 0 0 0 .007-.013Zm-1.345-.292L6.001 7.99 5.08 9.833h1.176l.333-.666Z" />
      <path d="M.668 3.167a2 2 0 0 1 2-2h10.667a2 2 0 0 1 2 2v10.666a2 2 0 0 1-2 2H2.668a2 2 0 0 1-2-2V3.167Zm2-.667a.667.667 0 0 0-.667.667v10.666c0 .369.299.667.667.667h10.667a.667.667 0 0 0 .666-.667V3.167a.667.667 0 0 0-.666-.667H2.668Z" />
    </g>
  </SVGIcon>
);
